module.exports = __webpack_public_path__ + "img/_3.bc56ff92.png";